<script setup>

import SelectInput from "@/components/global-themed/inputs/SelectInput.vue";
import DefaultButton from "@/components/global-themed/buttons/DefaultButton.vue";
import {useStore} from "vuex";
import {getCompetitors} from "@/composables/backlinks/opportunity/useCompetitors";
import useOpportunityStore from "@/composables/backlinks/opportunity/useOpportunityStore";
import SearchInput from "@/components/global-themed/SearchInput.vue";

const store = useStore();

const {search, activeCompetitor } = useOpportunityStore();

const { data: competitors, isFetching } = getCompetitors();

const onSearchInput = (value) => {
  store.dispatch('backlinkOpportunity/setSearch', value);
}
</script>

<template>
  <div class="tw-grid tw-grid-cols-12 tw-gap-4 tw-items-end tw-py-8">
    <div
      class="tw-col-span-2"
    >
      <SelectInput
        :disabled="isFetching"
        class="tw-text-grey-dark"
        @input="(e) => store.dispatch('backlinkOpportunity/setActiveCompetitor', e.target.value)"
      >
        <option
          value=""
          :selected="activeCompetitor === ''"
        >
          All Competitors
        </option>
        <option
          v-for="competitor in competitors"
          :key="competitor.id"
          :value="competitor.simpleUrl"
          :selected="activeCompetitor === competitor.simpleUrl"
        >
          {{ competitor.simpleUrl }}
        </option>
      </SelectInput>
    </div>

    <div class="tw-col-span-4">
      <SearchInput
        v-model="search"
        placeholder="Search Backlink"
        @update:model-value="onSearchInput"
      />
    </div>

    <div class="tw-col-span-6 tw-flex tw-items-center tw-justify-end tw-gap-4">
      <DefaultButton
        variant="primary-inverted"
        as="a"
        class="py-2 px-4"
        href="/backlinks/opportunity/export"
        size="small"
      >
        <span class="tw-font-semibold tw-antialiased">Export</span>
        <svg-vue
          icon="icons/download"
          class="tw-w-5 tw-h-5 tw-ml-2"
        />
      </DefaultButton>
    </div>
  </div>
</template>

